import VeeValidate, { Validator } from 'vee-validate'
import enDictionary from 'vee-validate/dist/locale/en'
import ptBrDictionary from 'vee-validate/dist/locale/pt_BR'
import Vue from 'vue'
import i18n from './i18n'
import validators from './lib/validators'

export function setupVeeValidate() {
  validators.forEach(item => {
    Validator.extend(item.name, item.validator)
  })

  Vue.use(VeeValidate, {
    i18nRootKey: 'validations', // customize the root path for validation messages.
    i18n,
    dictionary: {
      en: enDictionary,
      'pt-BR': ptBrDictionary
    }
  })
}
